import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { take } from 'rxjs';
import timeGridPlugin from '@fullcalendar/timegrid';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import { CalendarOptions } from '@fullcalendar/core';
import { MatDialog } from '@angular/material/dialog';
import { ProfessionalService } from '../../../shared/services/professional.service';
import { ScalesDetailsDialogComponent } from '../../scales/scales-details-dialog/scales-details-dialog.component';

@Component({
  selector: 'app-calendar-scale-professional',
  templateUrl: './calendar-scale-professional.component.html',
  styleUrls: ['./calendar-scale-professional.component.scss']
})
export class CalendarScaleProfessionalComponent {
  private professionalId: string;
  isLoading: boolean = false;

  calendarOptions: CalendarOptions = {
    plugins: [timeGridPlugin, dayGridPlugin, listPlugin],
    initialView: this.isMobile() ? 'listWeek' : 'timeGridWeek',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: this.isMobile() ? '' : 'listWeek,dayGridMonth,timeGridWeek,timeGridDay'
    },
    eventOverlap: false,
    aspectRatio: 1.5,
    editable: true,
    selectable: true,
    eventMinHeight: 30,
    slotMinWidth: 50,
    locale: 'pt-br',
    eventClick: this.handleEventClick.bind(this),
    datesSet: this.handleDatesSet.bind(this),
    eventColor: '',
    buttonText: {
      today: 'Hoje',
      month: 'Mês',
      week: 'Semana',
      day: 'Dia',
      list: 'Lista'
    }
  };

  constructor(
    public dialog: MatDialog,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private location: Location,
    private readonly professionalService: ProfessionalService) {}

  ngOnInit(): void {
    this.route.params.pipe(take(1)).subscribe((params: any) => {
      this.professionalId = params['id'];
    });
  }

  handleEventClick(clickInfo: any) {
    const event = clickInfo.event;

    this.dialog.open(ScalesDetailsDialogComponent, {
      data: {
        title: event.title,
        start: event.start,
        end: event.end,
        status: this.getTranslateStatusToBR(event.extendedProps.status),
        hospital: event.extendedProps.hospital,
        department: event.extendedProps.department,
        timeline: event.extendedProps.histories
      }
    });
  }

  goBack() {
    this.location.back();
  }

  private handleDatesSet(arg: any) {
    this.professionalService.getScales(arg.startStr.split('T')[0], arg.endStr.split('T')[0], this.professionalId).subscribe(
      (details: any) => {
        this.isLoading = false;
        this.calendarOptions.events = details.scales.map((scale: any) => ({
          title: `${scale.professionalNameDuty}`,
          start: scale.startDate,
          end: scale.endDate,
          status: scale.status,
          hospital: scale.hospital,
          department: scale.department,
          histories: scale.histories,
          backgroundColor: this.getColorForStatus(scale.status),
          borderColor: this.getColorForStatus(scale.status),
        }));
      },
      () => console.error('error')
    );
  }


  private isMobile(): boolean {
    return window.innerWidth <= 768;
  }

  private getColorForStatus(status: string): string {
    switch (status.toLowerCase()) {
      case 'registered':
        return 'lightblue';
      case 'started':
        return 'orange';
      case 'ended':
        return 'green';
      case 'no_show':
        return 'red';
      default:
        return 'gray';
    }
  }

  private getTranslateStatusToBR(status: string): string {
    switch (status.toLowerCase()) {
      case 'registered':
        return 'Cadastrado';
      case 'started':
        return 'Em andamento';
      case 'ended':
        return 'Encerrado';
      case 'no show':
        return 'Não compareceu';
      default:
        return 'Cadastrado';
    }
  }
}
